import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';

import { useMutation } from '@tanstack/react-query';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';

type UseRetrieveTemporalRouteResponseProps = ServiceResponse<Function, Route>;

export const useRetrieveTemporalRoute = (): UseRetrieveTemporalRouteResponseProps => {
  const {
    mutate: run,
    isLoading,
    isSuccess,
    isError,
    data: route,
  } = useMutation(
    async (routeId: string) => {
      const response = await routeService.fetchRoute({ routeId });
      return response;
    },
    {
      onSuccess: async (route) => {},
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    data: route,
    run,
  };
};
